import orderBy from "lodash/orderBy";
import type { FC } from "react";
import { useAuthContext } from "../../auth/AuthContext";
import { formatDate } from "../../data/dataUtils";
import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";
import NoteStampedInput from "../noteStampedList/NoteStampedInput";
import type { Note } from "./Notes";
import Notes from "./Notes";

interface Props {
  readonly notes: Note[];
  readonly contactDate: string | null;
  readonly readonly?: boolean;
  readonly deleteDisabled?: boolean;
  readonly onChange: (notes: Note[], contactDate: string | null) => void | Promise<void>;
}

const NotesWithDate: FC<Props> = ({ notes, contactDate, readonly, deleteDisabled, onChange }) => {
  const { user } = useAuthContext();
  const orderedNotes = orderBy(notes, (n) => n.date, ["desc"]);

  const handleAddNote = async (text: string, date: string | null) => {
    if (user?.email) {
      await onChange(
        [
          {
            text: date ? `${text} [data kontaktu: ${formatDate(date)}]` : text,
            date: dayjs().format(ISO_DATE_FORMAT),
            author: user.email,
          },
          ...orderedNotes,
        ],
        date || null,
      );
    } else {
      throw new Error("User email is required to add a note");
    }
  };

  const handleDeleteNote = async (idx: number) => {
    await onChange(
      orderedNotes.filter((n, i) => i !== idx),
      contactDate,
    );
  };

  return (
    <Notes notes={orderedNotes} onDeleteNote={deleteDisabled ? undefined : handleDeleteNote}>
      <NoteStampedInput
        date={contactDate}
        dateLabel="Data kontaktu"
        label="Nowa notatka"
        readonly={readonly}
        onSubmit={handleAddNote}
      />
    </Notes>
  );
};

export default NotesWithDate;
